const INITIAL_LIMIT = 3;

const initialState = {
  status: 'initial',
  query: '',
  limit: INITIAL_LIMIT,
  detail: { type: null, page: null },
  results: [],
  error: '',
};

export default initialState;
